import { Modal } from "@mui/material";
import styled from "styled-components";
import Colors from "../../../constants/Colors";

export const SchedulingCardModal = styled(Modal)<{
  useBackgroundColor?: boolean;
}>`
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  ${({ useBackgroundColor }) =>
    useBackgroundColor && "background-color: rgba(0, 0, 0, 0.3);"}
`;
export const SchedulingCardModalContainer = styled.div<{ isMobile?: boolean }>`
  display: flex;
  border-radius: 8px;
  align-items: center;
  justify-content: center;
  overflow: scroll;
  background-color: #ffffff;
  width: ${props => (props.isMobile ? "100%" : "80vw")};

  ::-webkit-scrollbar {
    display: none;
  }

  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none;
`;

export const ModalSchedulingCardContainer = styled.div`
  overflow: scroll;
  overflow-x: hidden;
  overflow-y: auto;
  padding: 36px 102px;

  @media screen and (max-width: 760px) {
    padding: 10px;
    width: 100%;
  }

  @media screen and (max-height: 600px) {
    height: 400px;
  }
`;

export const ModalSchedulingMedicCardContainer = styled.div`
  display: flex;
  align-items: center;

  @media screen and (max-width: 760px) {
    flex-direction: column;
  }

  gap: 10px;
  width: 100%;
  /* justify-content: center; */
`;

export const ModalSchedulingTextCardContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const ModalSchedulingTimeCardContainer = styled.div`
  display: flex;
  @media screen and (max-width: 760px) {
    flex-direction: column;
  }
  gap: 10px;
  align-items: center;
`;

export const ModalSchedulingHoursContainer = styled.div`
  display: flex;
  @media screen and (max-width: 760px) {
    flex-direction: column;
  }
  ${Colors.SPM500}
`;

export const ModalSchedulingHourCard = styled.div`
  display: flex;

  border-radius: 4px;

  text-align: center;
  @media screen and (max-width: 760px) {
    text-align: left;
  }
  background: ${Colors.SPM50};
  justify-content: center;
  align-items: center;
  padding: 4px 8px;
  max-height: 30px;
  gap: 10px;
`;

export const ModalSchedulingSubTextContainer = styled.div`
  text-align: left;
`;

export const ModalSchedulingButtonsContainer = styled.div`
  display: flex;

  width: 100%;
  gap: 10px;

  align-items: center;
  justify-content: center;
`;
